export function getEventLabelGM (value, i18n) {
  return `${(value.properties.location || {}).name}. Planta ${value.properties.levelName}. ${value.mode === 'point' ? `(${displayCoordinates(value.geometry.coordinates)})` : i18n.t(value.properties.attrs.pat_nombre)}`.toLowerCase()
}

function displayCoordinates (coordinates) {
  if (!coordinates || !coordinates.length) return ''
  const [y, x] = coordinates
  return [x, y].map(c => c.toFixed(5)).join(', ')
}
